import AlertMessage from "../../Components/AlertMessage/AlertMessage";
import ApiConfig from "../../Utils/Configs/apiConfig";

interface DuplicateDetectionPayload {
  clientId: string;
  isEnabled: boolean;
}

export const duplicateDetectionApi = async (
  payload: DuplicateDetectionPayload
) => {
  try {
    const response = await ApiConfig.getInstance().put(
      "/BusinessClient/duplicate-detection",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    AlertMessage({
      text: "Duplicate detection updated successfully",
      type: "success",
    });

    return response.data;
  } catch (error: any) {
    AlertMessage({
      text: "Failed to update duplicate detection",
      type: "error",
    });

    console.error(
      "Error updating duplicate detection:",
      error
    );

    throw error.response?.data || error.message;
  }
};

export const compareDuplicateInvoiceApi = async (
  invoiceId: number
) => {
  try {
    const response = await ApiConfig.getInstance().get(
      `/Invoice/duplicates/${invoiceId}/compare`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    AlertMessage({
      text: "Failed to compare duplicate invoice",
      type: "error",
    });

    console.error(
      "Error comparing duplicate invoice:",
      error
    );

    throw error.response?.data || error.message;
  }
};

export const resolveDuplicateApi = async (
  flagId: number,
  status: number
) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Invoice/duplicates/resolve-duplicate",
      {
        flagId,
        status,
      }
    );

    AlertMessage({
      text: "Duplicate resolved successfully",
      type: "success",
    });

    return response.data;
  } catch (error: any) {
    AlertMessage({
      type: "error",
      text: "Failed to resolve duplicate",
    });

    console.error(
      "Error resolving duplicate:",
      error
    );

    throw error.response?.data || error.message;
  }
};

export const duplicateDetectionApistatus = async (
  userId: string
) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/BusinessClient/duplicate-detection",
      {
        clientId: userId,
      }
    );

    console.log("duplicateDetectionApistatus Response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("duplicateDetectionApistatus Error:", error);
    throw error.response?.data || error.message;
  }
};